import styled from 'styled-components';
import { headerHeight } from '@dealstack/frontend/shared/mechanism/styleguide/GlobalStyling';

export const Container = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	min-height: 0;
	background-color: #ffffff;
	border-radius: 0.25rem;
	border: 1px solid #e5e7eb;
`;

export const ValuationsLoaderContainer = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	position: relative;
`;

export const ComputeProgressLabel = styled.div`
	position: absolute;
	top: calc(50% + 32px);
	width: 100%;
	text-align: center;
	color: ${({ theme }) => theme.v2.color.neutral[500]};
	font-size: 13px;
`;

export const TitleContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;
`;

export const InPageContainer = styled.div`
	display: grid;
	grid-template-rows: auto 1fr;
	grid-template-columns: minmax(0, 1fr);
	gap: 1rem;
	height: calc(100vh - ${headerHeight});
	max-height: calc(100vh - ${headerHeight});
	background-color: ${({ theme }) => theme.v2.color.neutral[50]};
	padding: 1rem 2rem;
	box-sizing: border-box;
	overflow-y: hidden;
`;

export const ValuationsLayout = styled.div`
	display: grid;
	grid-template-rows: auto 1fr;
	gap: 1rem;
	overflow: hidden;
`;
